export default {
    palette: {
        primary: {
            light: '#4caf50',
            main: '#388e3c',
            dark: '#1b5e20',
            contrastText: '#fff',
        },
        secondary: {
            light: '#ffb500',
            main: '#f59c00',
            dark: '#e65100',
            contrastText: '#000',
        },
    },
    typography: {
        useNextVariants: true,
    },
};